import React, {Component} from 'react';
import { Link, withRouter } from 'react-router-dom';

import { PageSettings } from './../../config/page-settings.js';
import LogoSBMS from '../../assets/images/logoSBMS.png';
import LogoArtajasa from '../../assets/images/artajasa.png';
import VideoBG from '../../assets/videos/login-video-bg.mp4';

import withNotification from '../../components/HOCNotification/HOCNotification.component';
import Auth from '../../services/auth';
import { RESPONSE, COPYRIGHT } from '../../config/constants';
import Services from '../../services/service';

const auth = new Auth();
const { SUCCESS, FAILED } = RESPONSE;

class Login extends Component {
	static contextType = PageSettings;

	constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: ''
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }
  
	componentDidMount() {
		this.context.handleSetPageSidebar(false);
		this.context.handleSetPageHeader(false);
		this.context.handleSetBodyWhiteBg(true);
	}

	componentWillUnmount() {
		this.context.handleSetPageSidebar(true);
		this.context.handleSetPageHeader(true);
		this.context.handleSetBodyWhiteBg(false);
	}

  handleFieldChange = (key) => (e) => {
    const state = { [key]: e.target.value };
    this.setState(state);
  }
	
	handleSubmit(event) {
		event.preventDefault();
    const { username, password } = this.state;

    const payload = {
      username,
      password
    };

    Services.postLogin(payload)
    .then(res => {
      this.toggleNotification(SUCCESS);
      setTimeout(auth.handleAuthentication(res), 2000);
    })
    .catch(err => {
      console.log(err);
      this.toggleNotification(FAILED);
    });
  }

  toggleNotification = action => {
    switch(action){
      case SUCCESS:
        this.props.addNotification('success', 'Success', 'Login successful', 'top-right');
        break;
      case FAILED:
        this.props.addNotification('danger', 'Failed', 'Unauthorized', 'top-right');
        break;
      default:
        break;
    }
  };
  
	render() {
		return (
			<div className="login login-with-news-feed">
				<div className="news-feed">
					<div className="news-image login-cover">
            <video className="video-bg" autoPlay muted loop>
              <source src={VideoBG} type="video/mp4"/>
            </video>
            <div className="login-cover-bg"></div>
          </div>
					<div className="news-caption">
						<h4 className="caption-title">SIMPONI - ARTAJASA</h4>
            <p>Sistem Monitoring Perangkat Operasional Dan Infrastruktur</p>
					</div>
				</div>
				<div className="right-content">
					<div className="login-header">
						<div className="brand">
							<img src={LogoSBMS} alt="logo_sbms"></img>
							<small></small>
						</div>
						<div className="icon">
							<i className="fa fa-sign-in"></i>
						</div>
					</div>
					<div className="login-content">
						<form className="margin-bottom-0" onSubmit={this.handleSubmit}>
							<div className="form-group m-b-15">
								<input type="text" className="form-control form-control-lg" onChange={this.handleFieldChange('username')} placeholder="Email Address" required />
							</div>
							<div className="form-group m-b-15">
								<input type="password" className="form-control form-control-lg" onChange={this.handleFieldChange('password')} placeholder="Password" required />
							</div>
							{/* <div className="checkbox checkbox-css m-b-30">
								<input type="checkbox" id="remember_me_checkbox" value="" />
								<label htmlFor="remember_me_checkbox">
									Remember Me
								</label>
							</div> */}
							<div className="login-buttons">
								<button type="submit" className="btn btn-success btn-block btn-lg">Sign Me In</button>
							</div>
							<div className="m-t-20 m-b-40 p-b-40 text-inverse text-center">
								Forgot your password? Click <Link to="/user/change-password" className="text-success">here</Link> to reset.
							</div>
							<hr />
							<p className="text-center text-grey-darker">
								{COPYRIGHT}
							</p>
              <div className="text-center">
                <img src={LogoArtajasa} alt="logo_artajasa" width={"64px"}/>
              </div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default withNotification(withRouter(Login));